export const URL_REGEX =
  /^(?=.{4,2048}$)((http|https):\/\/)?(www\.)?(?!.*(http|https|www\.)[^\s]*\.[^\s]*[^\s])([a-zA-Z0-9_&=~-]{1,63}\.){1,5}[a-zA-Z]{1,63}(\/)?([\w&[a-zA-Z-_%/@?+=.-]+)*([^/\w?[a-zA-Z0-9_-]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/;

export const WALLET_REGEX = /^0x[a-fA-F0-9]{40}$/g;

export const validateImageType = (imageName: string): boolean => {
  return !!imageName.match(/\.(jpg|jpeg|png|gif)$/);
};

export const ONLY_DECIMAL_POSITIVE_NUMBERS_REGEX = /^[0-9]*\.?[0-9]*$/;

export const TWITTER_HANDLE_REGEX = /^@?(\w){1,15}$/;

// Discord snowflake ID (server/guild and role IDs): 17–20 digits.
// Mirrors the BE `@Matches(/^\d{17,20}$/)` validators on the discord trigger context schemas.
export const DISCORD_SNOWFLAKE_REGEX = /^\d{17,20}$/;

// Matches an X (Twitter) post/status URL and captures the numeric status id in group 4.
// Anchored at the start and x.com-only (rejects twitter.com), mirroring the fuul-server
// retweet trigger contract. No `g` flag so it stays stateless for repeated `.test()` calls.
export const X_POST_URL_REGEX = /^(https?:\/\/)?(www\.)?x\.com\/([a-zA-Z0-9_]+)\/status\/(\d+)/;

export const extractXPostId = (url: string): string | null => {
  const match = url.match(X_POST_URL_REGEX);
  return match?.[4] ?? null;
};

export const CONVERSION_OPERATORS_REGEX = /\b(AND|OR)\b/g;

export const CONVERSION_OPERATORS_TIME_SENSITIVE_REGEX = /\b(AND)\b/g;

export const ONLY_ALPHANUMERIC_REGEX = /^(?! *$)[a-zA-Z0-9\s]*$/;

export const NON_DECIMAL_NUMBERS_REGEX = /^[0-9]*$/;

export const ONLY_ALPHANUMERIC_WITH_UNDERSCORE_REGEX = /^[a-zA-Z0-9_-]+$/;

export const isValidUrl = (url: string): boolean => {
  if (!url) {
    return false;
  }
  // A more flexible regex for URL validation
  const urlRegex = new RegExp(
    '^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$', // fragment locator
    'i',
  );
  return urlRegex.test(url);
};
